import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import '../css/Tarjetacarrito.css';
import { get_productos } from '../redux/actions/productos';
import { connect } from 'react-redux';
import CategoryList from '../components/CategoryList';
import ProductCard from './ProductCard';
import { getSolicitud } from '../redux/actions/solicitud';
import useFuzzySearch from '../hooks/useFuzzySearch';

const Productscarrito = ({
    pedidoId,
    productos,
    get_productos,
    carrito,
    searchTerm,
    selectedProductId,
    searchField,
    getSolicitud,
    fecha_creacion,
    fecha_resolucion
}) => {
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const idPedidoParam = searchParams.get('idPedido');
    const currentPedidoId = pedidoId || idPedidoParam;
    const fuzzySearch = useFuzzySearch(productos, searchField);

    // maneja fechas de creacion y resolución de la solicitud para evitar
    //  que se resetee el store al hacer f5
    useEffect(() => {
        if (!(fecha_creacion && fecha_resolucion) && idPedidoParam) {
            getSolicitud(idPedidoParam);
        }
    }, [idPedidoParam, fecha_creacion, fecha_resolucion, getSolicitud]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (fecha_creacion && fecha_resolucion) {
            get_productos(fecha_creacion, fecha_resolucion, currentPedidoId);
        } else if (!idPedidoParam) {
            navigate('/request');
        }
    }, [get_productos, fecha_creacion, fecha_resolucion, currentPedidoId, idPedidoParam, navigate]);

    useEffect(() => {
        if (productos && selectedProductId) {
            setProductosFiltrados(productos.filter(producto => producto && producto.id === selectedProductId));
        } else if (productos && searchTerm) {
            setProductosFiltrados(fuzzySearch(searchTerm));
        } else {
            setProductosFiltrados(productos || []);
        }
    }, [productos, searchTerm, selectedProductId, searchField, fuzzySearch]);

    const handleCategoryChange = useCallback((categoria, seccion = null) => {
        if (categoria === "Todo") {
            setProductosFiltrados(productos || []); // Show all products
        } else {
            const filteredProducts = (productos || []).filter(producto =>
                producto && producto.categoria === categoria && (!seccion || producto.seccion === seccion)
            );
            setProductosFiltrados(filteredProducts);
        }
    }, [productos]);

    return (
        <main className='productos-carrito'>
            
            <CategoryList mostrarPorCategoria={handleCategoryChange} />
            <Link to={currentPedidoId ? `/fechas?idPedido=${currentPedidoId}` : '/fechas'} className="button volver-button">Volver</Link>
            <div className="card-container">
                {productosFiltrados && productosFiltrados.map((producto, index) => (
                    producto && (
                        <ProductCard
                            key={producto.id || index}
                            producto={producto}
                            itemsCarrito={carrito.items}
                        />
                    )
                ))}
            </div>
        </main>
    );
};

const mapStateToProps = state => ({
    productos: state.Productos.productos,
    carrito: state.Solicitud.carrito,
    fecha_creacion: state.Solicitud.fecha_creacion,
    fecha_resolucion: state.Solicitud.fecha_resolucion,
    searchTerm: state.Productos.searchTerm,
    selectedProductId: state.Productos.selectedProductId,
    searchField: state.Productos.searchField,
});

export default connect(mapStateToProps, {
    get_productos,
    getSolicitud
})(Productscarrito);